var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#FAAC3B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 15C31 13.9 30.1 13 29 13H13C11.9 13 11 13.9 11 15V27C11 28.1 11.9 29 13 29H29C30.1 29 31 28.1 31 27V15ZM29 15L21 20L13 15H29ZM29 27H13V17L21 22L29 17V27Z",
    fill: "#02292C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.25a45be0f1ee1f26b24ec56e16e6c104.svg";
export { ForwardRef as ReactComponent };